export default "__VITE_ASSET__iRM4sXX0__"